import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, TrendingDown, Users, Search, FileText, Globe, LineChart, CalendarX } from 'lucide-react';
const pains = [{
  icon: AlertCircle,
  title: 'Llegás sin saber qué hacer',
  desc: 'Sin protocolo claro para esa visita con ese paciente.'
}, {
  icon: TrendingDown,
  title: 'Pacientes que no progresan',
  desc: 'Sin estructura para pasar de un nivel al siguiente.'
}, {
  icon: Users,
  title: 'La familia no te sigue',
  desc: 'Sin material claro para cuando no estás presente.'
}, {
  icon: Search,
  title: 'Los mismos recursos básicos',
  desc: 'No sabés cómo intervenir en etapa moderada o severa.'
}, {
  icon: FileText,
  title: 'La obra social no te cubre',
  desc: 'Sin documentación profesional que lo justifique.'
}, {
  icon: Globe,
  title: 'Tips sueltos de internet',
  desc: 'Sin sistema clínico respaldado que te guíe.'
}, {
  icon: LineChart,
  title: 'No registrás el progreso',
  desc: 'Tu seguimiento se vuelve subjetivo y débil.'
}, {
  icon: CalendarX,
  title: 'Sin evidencia de resultados',
  desc: 'No podés demostrar el impacto de tu trabajo.'
}];
export const PainPoints = () => {
  return <section className="py-12 md:py-20 bg-white" data-id="element-188">
      <div className="max-w-5xl mx-auto px-4" data-id="element-189">
        <div className="text-center mb-8 md:mb-12" data-id="element-190">
          <h2 className="text-2xl md:text-4xl font-extrabold text-navy mb-2 md:mb-4" data-id="element-191">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-192">
            Si trabajás como TO domiciliario en Argentina, esto te suena
            familiar:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-2.5 md:gap-3" data-id="element-193">
          {pains.map((pain, i) => {
          const Icon = pain.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className="flex items-center gap-3 md:gap-4 bg-cream rounded-xl border border-gray-100 p-3 md:p-4 hover:border-danger/30 hover:shadow-md hover:translate-x-1 transition-all group" data-id="element-194">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white border border-danger/20 flex items-center justify-center shadow-sm group-hover:bg-danger group-hover:border-danger transition-colors" data-id="element-195">
                  <Icon className="w-5 h-5 md:w-6 md:h-6 text-danger group-hover:text-white transition-colors" data-id="element-196" />
                </div>
                <div className="flex-grow min-w-0" data-id="element-197">
                  <h3 className="font-bold text-navy text-sm md:text-base leading-tight mb-0.5" data-id="element-198">
                    {pain.title}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 leading-snug" data-id="element-199">
                    {pain.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="mt-10 md:mt-14 text-center" data-id="element-200">
          <p className="text-base md:text-xl font-bold text-navy max-w-3xl mx-auto leading-snug" data-id="element-201">
            ¿Cuántas visitas más vas a hacer sin un sistema que respalde cada
            decisión clínica?
          </p>
        </div>
      </div>
    </section>;
};